import type { RouteLocationRaw } from 'vue-router';

export default defineNuxtRouteMiddleware((to) => {
  const partner = localStorage.getItem('partnerName');
  const sessionToken = localStorage.getItem('sessionToken');

  let redirect: RouteLocationRaw | undefined;

  if (!to.params.partner && partner) {
    redirect = {
      name: 'home',
      params: { partner }
    };
  } else if (to.params.partner) {
    // If go to a page requiring authentication but not signed in yet (no sessionToken or different partnerName)
    if (
      to.matched.some(
        (route) => Array.isArray(route.meta.middleware) && route.meta.middleware.includes('auth')
      ) &&
      (!sessionToken || to.params.partner.toString().toLowerCase() !== partner?.toLowerCase())
    ) {
      const lastVisited = to.fullPath.split('/').slice(2).join('/');

      // Redirect to the sign in page
      redirect = {
        name: 'partner-sign-in',
        params: { partner: to.params.partner }
      };

      if (lastVisited) {
        redirect.query = { redirect: lastVisited };
      }
    } else if (
      to.name === 'partner-sign-in' &&
      sessionToken &&
      to.params.partner.toString().toLowerCase() === partner?.toLowerCase()
    ) {
      const lastVisited = to.query && to.query.redirect;
      // Redirect to home page or lastVisited
      if (lastVisited) {
        redirect = `${partner}/${lastVisited}`;
      } else {
        redirect = {
          name: 'partner-home',
          params: { partner }
        };
      }
    }
  }

  if (redirect) {
    return navigateTo(redirect);
  }
});
